import { SxProps, Theme } from '@mui/material';

export const gridContainerStyle: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: 2,
  width: '100%',
};

export const categoryCardStyle = (isSelected: boolean, isDisabled: boolean = false): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'center',
  padding: '12px 16px',
  borderRadius: '8px',
  border: isDisabled ? '1px solid #D0D5DD' : isSelected ? '1px solid #296C32' : '1px solid #E5E7EB',
  background: isDisabled ? '#EAECF0' : isSelected ? '#F2FBF3' : '#FFF',
  cursor: isDisabled ? 'not-allowed' : 'pointer',
  boxSizing: 'border-box',
  minHeight: '52px',
  opacity: isDisabled ? 0.6 : 1,
  '&:hover': {
    borderColor: isDisabled ? '#D0D5DD' : '#296C32',
  },
});

export const formControlLabelStyle: SxProps<Theme> = {
  margin: 0,
  width: '100%',
  cursor: 'pointer',
  userSelect: 'none',
};

export const checkboxStyle: SxProps<Theme> = {
  '& .MuiSvgIcon-root': {
    fontSize: 20,
  },
};

export const categoryTitleStyle = (isSelected: boolean): SxProps<Theme> => ({
  fontSize: 14,
  fontWeight: isSelected ? 600 : 400,
  color: isSelected ? '#296C32' : '#475467',
});
